"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var react_redux_1 = require("react-redux");
var GamePointIcon_1 = __importDefault(require("./GamePointIcon"));
function GamePoints(_a) {
    var _b;
    var playerId = _a.playerId, _c = _a.suspense, suspense = _c === void 0 ? 0.1 : _c, test = _a.test, props = __rest(_a, ["playerId", "suspense", "test"]);
    var player = (0, react_redux_1.useSelector)(function (state) { return state.players.find(function (p) { return p.id === playerId; }); });
    var gamePointsDelta = (_b = player === null || player === void 0 ? void 0 : player.gamePointsDelta) !== null && _b !== void 0 ? _b : test;
    var _d = (0, react_2.useState)(false), hidden = _d[0], setHidden = _d[1];
    (0, react_2.useEffect)(function () {
        if (player && gamePointsDelta === undefined) {
            setHidden(true);
        }
        else if (hidden && gamePointsDelta !== undefined) {
            setTimeout(function () { return setHidden(false); }, suspense * 1000);
        }
    }, [player, gamePointsDelta, hidden, suspense, setHidden]);
    if (gamePointsDelta === undefined)
        return null;
    return (0, jsx_runtime_1.jsxs)("span", __assign({ css: [style, hidden && hiddenCss] }, props, { children: [(0, jsx_runtime_1.jsx)(GamePointIcon_1.default, {}), gamePointsDelta > 0 && '+', gamePointsDelta] }));
}
exports.default = GamePoints;
var style = (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  transition: opacity 0.3s;\n"], ["\n  display: flex;\n  align-items: center;\n  transition: opacity 0.3s;\n"])));
var hiddenCss = (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  opacity: 0;\n"], ["\n  opacity: 0;\n"])));
var templateObject_1, templateObject_2;
